import { render, staticRenderFns } from "./CategoryTemplate.vue?vue&type=template&id=3c642d02&name=category-template&"
import script from "./CategoryTemplate.vue?vue&type=script&lang=js&"
export * from "./CategoryTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CategoryTemplate.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports